var map = {
	"./apaleo.png": 11372,
	"./avalon2.png": 22163,
	"./avirato.png": 74048,
	"./bookipro.png": 92321,
	"./catalonia.png": 68184,
	"./civitfun.png": 25948,
	"./cloudbeds.png": 65993,
	"./elektraweb.png": 77976,
	"./ericsoft.png": 19605,
	"./guestline.png": 7796,
	"./guestportal.png": 31276,
	"./guestpro.png": 13201,
	"./hestia.png": 38318,
	"./host.png": 37490,
	"./hoteliga.png": 91983,
	"./mews.png": 86260,
	"./minihotel.png": 94475,
	"./noray.png": 17181,
	"./noray_htl.png": 33404,
	"./noray_new.png": 75726,
	"./octorate.png": 53999,
	"./ohip.png": 32646,
	"./ohip_new.png": 48937,
	"./ohipdynamic.png": 18135,
	"./ohtels.png": 18407,
	"./oldCivitfun.png": 8737,
	"./opera.png": 53219,
	"./othello.png": 32101,
	"./passepartout.png": 83061,
	"./porthotels.png": 24244,
	"./protel.png": 59592,
	"./rms.png": 24012,
	"./roomcloud.png": 98658,
	"./selentagroup.png": 28617,
	"./sihot.png": 11671,
	"./sihot360.png": 51346,
	"./stelle.png": 20847,
	"./suite.png": 7234,
	"./suitech.png": 12003,
	"./tecsoft.png": 62594,
	"./timon.png": 58083,
	"./tms.png": 36062,
	"./totvs.png": 22854,
	"./ulysescloud.png": 10372,
	"./ulysescloud_new.png": 23403,
	"./verial.png": 91203,
	"./winhotel.png": 9044,
	"./winhotel_new.png": 75003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20619;